"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeDifferenceInUnits = exports.getDifference = void 0;
var react_1 = require("react");
exports.getDifference = function (endTime) {
    var countDownDate = new Date(endTime).getTime();
    var now = new Date().getTime();
    return countDownDate - now;
};
exports.getTimeDifferenceInUnits = function (endTime, disableDays) {
    if (disableDays === void 0) { disableDays = false; }
    var days = 0;
    var hours = 0;
    var minutes = 0;
    var seconds = 0;
    var distance = exports.getDifference(endTime);
    if (distance <= 0) {
        return [days, hours, minutes, seconds];
    }
    days = Math.floor(distance / (1000 * 60 * 60 * 24));
    hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    // If the days are disabled, add them to hours
    if (disableDays) {
        hours = days * 24 + hours;
    }
    minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    seconds = Math.floor((distance % (1000 * 60)) / 1000);
    return [days, hours, minutes, seconds];
};
function useTimer(endTime, disableDays) {
    if (endTime === void 0) { endTime = new Date().toISOString(); }
    if (disableDays === void 0) { disableDays = false; }
    var initDistance = exports.getDifference(endTime);
    var _a = exports.getTimeDifferenceInUnits(endTime, disableDays), initDays = _a[0], initHours = _a[1], initMinutes = _a[2], initSeconds = _a[3];
    var _b = react_1.useState(initDays), days = _b[0], setDays = _b[1];
    var _c = react_1.useState(initHours), hours = _c[0], setHours = _c[1];
    var _d = react_1.useState(initMinutes), minutes = _d[0], setMinutes = _d[1];
    var _e = react_1.useState(initSeconds), seconds = _e[0], setSeconds = _e[1];
    var _f = react_1.useState(initDistance <= 0), done = _f[0], setDone = _f[1];
    react_1.useEffect(function () {
        var interval = 0;
        var distance = exports.getDifference(endTime);
        if (distance > 0) {
            var timer = function (timerInterval) {
                var _a = exports.getTimeDifferenceInUnits(endTime, disableDays), newDays = _a[0], newHours = _a[1], newMinutes = _a[2], newSeconds = _a[3];
                setDays(newDays);
                setHours(newHours);
                setMinutes(newMinutes);
                setSeconds(newSeconds);
                var newDistance = exports.getDifference(endTime);
                var isDone = newDistance <= 0;
                setDone(isDone);
                if (isDone) {
                    clearInterval(timerInterval);
                }
            };
            interval = setInterval(timer, 1000);
        }
        return function () { return clearInterval(interval); };
    }, [endTime, disableDays]);
    return [days, hours, minutes, seconds, done];
}
exports.default = useTimer;
//# sourceMappingURL=useTimer.js.map